module.exports = __webpack_public_path__ + "static/media/9.8d946426.png";